import { Component } from '@angular/core'
import { CmsComponentConnector, CmsLinkComponent, RoutingService } from '@spartacus/core'
import { OutletContextData } from '@spartacus/storefront'
import { Observable } from 'rxjs'
import { map, switchMap } from 'rxjs/operators'
import { EbFormFieldComponentOutletContextData } from '../../../../form/interfaces/eb-form.interface'

@Component({
    selector: 'eb-contact-form-rfp-hint',
    templateUrl: './eb-contact-form-rfp-hint.component.html',
    styleUrls: ['./eb-contact-form-rfp-hint.component.scss'],
    standalone: false
})
export class EbContactFormRfpHintComponent {
  linkComponent$: Observable<CmsLinkComponent>

  constructor(
    protected routingService: RoutingService,
    protected cmsComponentConnector: CmsComponentConnector,
    public contextData: OutletContextData<EbFormFieldComponentOutletContextData>
  ) {
    this.linkComponent$ = this.routingService
      .getRouterState()
      .pipe(
        switchMap(routerState =>
          this.cmsComponentConnector
            .getList(['rfpFormLink'], routerState.state.context)
            .pipe(map(components => components[0]))
        )
      )
  }
}
